export const colorTokens = {
  hatoBrand: {
    primary: {
      dark: '#001d66',
      pressedFocus: '#0958d9',
      active: '#0092ff',
      hover: '#29a9ff',
      borderLine: '#7ad3ff',
      bgContainer: '#e6f8ff',
    },
    secondary: {
      dark: '#000b1f',
      pressedFocus: '#001a45',
      active: '#002b68',
      hover: '#0d3c7f',
      borderLine: '#224f97',
      bgContainer: '#4f6fac',
    },
    tertiary: {
      dark: '#6b3318',
      pressedFocus: '#b86d3b',
      active: '#de8e52',
      hover: '#ebb07c',
      borderLine: '#ffedd9',
      bgContainer: '#fff9f0',
    },
    alternative: {
      dark: '#120063',
      pressedFocus: '#3005b0',
      active: '#4711d5',
      hover: '#6d36e3',
      borderLine: '#b88dfc',
      bgContainer: '#f1e6ff',
    },
  },
  text: {
    primary: '#262626',
    secondary: '#8c8c8c',
    disable: '#bfbfbf',
    white: '#ffffff',
    label: '#29a9ff',
    link: '#096dd9',
  },
  element: {
    black: '#262626',
    darkGrey: '#8c8c8c',
    lightGreyDisable: '#bfbfbf',
    border: '#d9d9d9',
    divider: '#f0f0f0',
    bgContainer1: '#f5f5f5',
    bgContainer2: '#fafafa',
    white: '#ffffff',
    bgOpacityModal: '#00000066',
    shadowMedium: '#00000033',
    shadowLight: '#00000026',
  },
  status: {
    success: {
      pressFocus: '#389e0d',
      active: '#52c41a',
      hover: '#73d13d',
      borderLine: '#b7eb8f',
      bgContainer: '#f6ffed',
    },
    warning: {
      pressFocus: '#d46b08',
      active: '#fa8c16',
      hover: '#ffa940',
      borderLine: '#ffd591',
      bgContainer: '#fff7e6',
    },
    error: {
      pressFocus: '#cf1322',
      active: '#f5222d',
      hover: '#ff4d4f',
      borderLine: '#ffa39e',
      bgContainer: '#fff1f0',
    },
    info: {
      pressFocus: '#096dd9',
      active: '#1890ff',
      hover: '#40a9ff',
      borderLine: '#91d5ff',
      bgContainer: '#e6f7ff',
    },
  },
}

export type ColorTokens = typeof colorTokens
export type ColorCategories = keyof ColorTokens
export type ColorKeys<T extends ColorCategories> = keyof ColorTokens[T]
